module.exports = __webpack_public_path__ + "static/media/tea-bag.ace4bdcc.svg";